import React from 'react';

import { Value, ValueTypeConfig } from '../common/Content.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region TAX

function TaxLine(props) {
    const data = props.data || {};
    let gst = false;
    if (data.Inventory) {
        for (let i = 0; i < data.Inventory.length; i++) {
            if (data.Inventory[i].Tax == 1) {
                gst = true;
                break;
            }
        }
    }
    if (!props.builder && !gst) {
        return null;
    }
    let design;
    if (gst && props.config && props.config.config && props.config.config.Block) {
        design = props.config.config.Block.design;
    }
    return <Value {...props} value={design} />
}
const TypeConfig = {
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Display Text',
                        fullWidth: true,
                        group,
                        name: 'design',
                        type: 'rich-text-collateral',
                        value: Utilities.wrapTextForEditor({ text: 'Tax Invoice' })
                    }
                ]
            };
        },
        style: () => ValueTypeConfig.panel.style('style')
    }
};

// #endregion TAX

export {
    TaxLine as Component,
    TypeConfig
}